import { z } from 'zod';

export const cargoInputSchema = z.object({
  descricao: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  ativo: z.boolean().optional(),
});

export type CargoFormValues = z.infer<typeof cargoInputSchema>;
